
import { APICall, enqueueAPICall } from './api-utils';

export const fetchUserState = () => APICall({
  method: 'get',
  url: '/api-app/state',
});

export const searchFleet = (fleet, model, params, options={}) => {
  const { type } = options;
  let url = `/api-app/${fleet}/search/${model}`;
  if(type){
    url = `${url}/${type}`;
  }
  return APICall(
    {
      method: 'get',
      url,
      params
    },
    {
      cacheDurationSeconds: 60,
      allowedStatuses: [400, 404],
      ...options
    }
  );
};

export const getInProcess = (fleet, params) => APICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/in_process`,
    params
  },
  {
    cacheDurationSeconds: 60 * 0.5
  }
);

export const getLocation = (fleet, locationId) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}`
  },
  {
    cacheDurationSeconds: 60 * 0.5
  }
);

export const updateLocation = (fleet, locationId, data) => APICall(
  {
    method: 'PUT',
    url: `/api-app/${fleet}/location/${locationId}`,
    data
  }
);

export const locationListUserAccesses = (fleet, locationId, params={}, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/user_access`,
    params
  },
  {
    cacheDurationSeconds: 60 * 0.5,
    ...options
  }
);

export const locationListInstallations = (fleet, locationId, params, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/installation`,
    params
  },
  {
    cacheDurationSeconds: 60 * 0.5,
    ...options
  }
);

export const locationListInstallationsExtended = (fleet, locationId, params, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/installation/extended`,
    params
  },
  {
    cacheDurationSeconds: 60 * 5,
    ...options
  }
);

export const locationGetTimeseries = (fleet, locationId, params, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/timeseries`,
    params
  },
  {
    cacheDurationSeconds: 60 * 60 * 12,
    allowedStatuses: [404],
    ...options
  }
);

export const locationGetAggregate = (fleet, locationId, params, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/aggregate`,
    params
  },
  {
    cacheDurationSeconds: 60 * 60 * 3,
    ...options
  }
);

export const locationGetAggregateToNearestInterval = (fleet, locationId, params) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/aggregate_to_nearest_interval`,
    params
  },
  {
    cacheDurationSeconds: 60 * 60 * 3
  }
);

export const locationGetCSV = (fleet, locationId, params) => enqueueAPICall({
  method: 'get',
  url: `/api-app/${fleet}/location/${locationId}/csv`,
  params
});

export const locationGetMetadata = (fleet, locationId, params, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/metadata`,
    params
  },
  {
    cacheDurationSeconds: 60 * 60,
    ...options
  }
);

export const locationGetRegisters = (fleet, locationId, params) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/registers`,
    params
  }  
);

export const impersonate = (fleet, userId, data) => APICall(
  {
    method: 'post',
    url: `/api-app/${fleet}/impersonate/${userId}`,
    data,
  }
);

export const removeUserAccess = (fleet, id) => APICall({
  method: 'delete',
  url: `/api-app/${fleet}/user_access/${id}`
});

export const addUserToLocationByEmail = (fleet, locationId, email) => APICall({
  method: 'post',
  url: `/api-app/${fleet}/location/${locationId}/user`,
  data: {
    email
  }
});

export const sendClaim = (fleet, locationId, data) => APICall({
  method: 'post',
  url: `/api-app/${fleet}/location/${locationId}/send_claim`,
  data
});

export const getUserDetailByEmail = (fleet, params) => enqueueAPICall({
  method: 'get',
  url: `/api-app/${fleet}/user_detail_by_email`,
  params
});

export const updateUserDetail = (fleet, userId, userDetail) => APICall({
  method: 'patch',
  url: `/api-app/${fleet}/user_detail/${userId}`,
  data: userDetail
})

export const getInstallation = (fleet, hubSerial, params) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/installation/${hubSerial}`,
    params
  }
);

export const updateInstallation = (fleet, hubSerial, data) => APICall(
  {
    method: 'put',
    url: `/api-app/${fleet}/installation/${hubSerial}`,
    data
  }
);

export const getHub = (fleet, hubSerial, params, options) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/hub/${hubSerial}`,
    params
  },
  {
    cacheDurationSeconds: 60 * 30,
    ...options
  }
);

export const getHubConnectivity = (fleet, hubSerial, params, options={}) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/hub_connectivity/${hubSerial}`,
    params
  },
  {
    cacheDurationSeconds: 60 * 30,
    ...options
  }
);

export const getEnergyProjectionsForHub = (fleet, hubSerial, params) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/energy-projections/hub/${hubSerial}`,
    params
  }
);

export const upsertEnergyProjectionsForHub = (fleet, hubSerial, data) => APICall(
  {
    method: 'post',
    url: `/api-app/${fleet}/energy-projections/hub/${hubSerial}`,
    data
  }
);

export const updateAdminUserDetail = data => APICall(
  {
    method: 'patch',
    url: '/api-app/user-detail',
    data
  }
);

export const updateAdminUser = data => APICall(
  {
    method: 'patch',
    url: '/api-app/protected/admin-user',
    data
  }
);

export const getLocationBilling = (fleet, locationId) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/billing`
  }
);

export const updateLocationBilling = (fleet, locationId, data) => APICall(
  {
    method: 'put',
    url: `/api-app/${fleet}/location/${locationId}/billing`,
    data
  }
);

export const getLocationTariff = (fleet, locationId) => enqueueAPICall(
  {
    method: 'get',
    url: `/api-app/${fleet}/location/${locationId}/tariff`
  }
);

export const listTariffs = params => enqueueAPICall(
  {
    method: 'get',
    url: '/api-app/tariffs',
    params
  }
);

export const updateLocationTariff = (fleet, locationId, masterTariffId) => APICall(
  {
    method: 'put',
    url: `/api-app/${fleet}/location/${locationId}/tariff/${masterTariffId}`
  }
);

export const getPermissions = (fleet) => APICall(
  {
    method: 'get',
    url:`/api-app/${fleet}/permissions`
  }
)